import React from "react";
import PropTypes from "prop-types";
import Item from "./Item";

const DocumentDownloadItem = ({ items }) => {
  return (
    <div className="documentDownload__area">
      {items.map((item, index) => (
        <Item
          key={index}
          name={item.name}
          size={item.size}
          onDownload={item.onDownload}
        />
      ))}
    </div>
  );
};

DocumentDownloadItem.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      onDownload: PropTypes.func.isRequired,
    }),
  ).isRequired,
};

export default DocumentDownloadItem;
